import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useAuditTrailEvents({ documentKey }: { documentKey: string }) {
  return useSuspenseQuery({
    ...apiClient.getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions({
      path: { key: documentKey },
    }),
  })
}
